
import axios from 'axios'
import env from "./config/env"
//expose axios to global object
window.axios = axios;

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

if (env.wsEnabled) {
    var useTLS = env.wsScheme === 'https';

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: env.wsKey,
        cluster: env.wsCluster,
        wsHost: env.wsHost,
        wsPort: env.wsPort,
        wssPort: env.wssPort || env.wsPort,
        forceTLS: useTLS,
        enabledTransports: ['ws'],
        disableStats: true,
        authorizer: channel => ({
            authorize: (socketId, callback) => {
                axios.post(env.normalURL + 'broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channel.name,
                })
                    .then(response => callback(false, response.data))
                    .catch(error => callback(true, error));
            },
        }),
    });
}

window.$ = window.jQuery = require('jquery');
require('bootstrap');
